// extracted by mini-css-extract-plugin
module.exports = {"header_mobile":"headerMobile_header_mobile__13GGR"};